import React from "react";
  type LoadingWrapperProps = React.PropsWithChildren<{
    isLoading: boolean;
    skeleton?: React.ReactNode;
    keepMounted?: boolean;
    overlay?: boolean;
    className?: string;
  }>;
  
  export function LoadingWrapper({
    isLoading,
    skeleton = null,
    keepMounted = false,
    overlay = false,
    className,
    children = null,
  }: LoadingWrapperProps) {
    //Just show skeleton
    if (isLoading && !keepMounted && !overlay) return <>{skeleton}</>;
  
    // KeepMounted / Overlay modes
    return (
      <div className={`relative ${className ?? ""}`} aria-busy={isLoading}>
        {overlay && isLoading && (
          <div className="absolute inset-0 z-10">{skeleton}</div>
        )}
        <div className={!overlay && isLoading ? "opacity-0 pointer-events-none select-none" : ""}>
          {children}
        </div>
        {!overlay && isLoading && <div aria-hidden>{skeleton}</div>}
      </div>
    );
  }
  
  